import React from 'react';

const SpennerPage = () => {
    return (
        <div className='flex justify-center items-center h-full'>
        <p className='text-7xl font-thin'></p>
        <div className='w-10 h-10 border-8 border-dashed rounded-full animate-spin mt-5 border-indigo-400'></div>
        <p className='text-7xl font-thin'></p>
     
      </div>
    );
};

export default SpennerPage;